











import { Vue, Component, Prop } from "@/shared/vuepack";
import { isNullEmptyOrUndefined } from "@/shared/stringHelper";
import moment from "moment/moment";

@Component

export default class ConsumerLInkedAccountAlert extends Vue {

  @Prop()
  isInErrorState: boolean;

  @Prop()
  errorMessage: string;

  @Prop()
  errorDate: string;

  getFormattedDate (date?: string): string {
    if (isNullEmptyOrUndefined(date)) {
      return "";
    }
    const local = moment.utc(date).local();
    if (isNullEmptyOrUndefined(local.zoneAbbr())) {
      return `${local.format("MM/DD/YYYY hh:mma")} ${local.tz(moment.tz.guess()).zoneAbbr()}`;
    }
    return local.format("MM/DD/YYYY hh:mma z");
  }
}
